import { Modal, Button } from "antd";
import "./RemoveLocationModal.scss";
import { useEffect, useState } from "react";
import { LocationDto } from "../../../generated/account-client";
import { useNavigate } from "react-router-dom";
import { env } from "../../../env/env";

export type MemberFieldType = "no" | "email" | "password" | "name";

export interface RemoveLocationModalProps {
  visible: boolean;
  location: LocationDto;
  onCancel: () => void;
  onRemoveAndTransferFiles: (location: LocationDto) => void;
  onDelete: (location: LocationDto) => void;
  userCount?: number;
  screenCount?: number;
}

export default function RemoveLocationModal({
  location,
  visible,
  onCancel,
  onRemoveAndTransferFiles,
  onDelete,
  userCount = 0,
  screenCount = 0,
}: RemoveLocationModalProps) {
  const [loc, setLoc] = useState({} as LocationDto);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [deleteForever, setDeleteForever] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!visible) return;
    let modalTitle = `Remove ${location.name} permanently?`;
    let modalBody = "You can transfer all your files elsewhere if you'd like.";
    
    if (userCount > 0) {
      modalTitle = `There ${userCount === 1 ? 'is' : 'are'} ${userCount} ${userCount === 1 ? 'User' : 'Users'} assigned to this Location.`;
      modalBody = `Please assign the ${userCount === 1 ? 'User' : 'Users'} to another Location or remove access for all Users.`;
    } else if (screenCount > 0) {
      modalTitle = `There ${screenCount === 1 ? 'is' : 'are'} ${screenCount} ${screenCount === 1 ? 'Screen' : 'Screens'} assigned to this Location.`;
      modalBody = `Please remove all Screens from this Location.`;
    }

    setLoc(location);
    setTitle(modalTitle);
    setBody(modalBody);
    setDeleteForever(false);
    setLoading(false);
  }, [location, visible, userCount, screenCount]);

  const onRemoveAndDeleteFiles = () => {
    const modalTitle = `Are you sure you want to delete all files from ${location.name}?`;
    const modalBody = "";
    setTitle(modalTitle);
    setBody(modalBody);
    setDeleteForever(true);
  };

  return (
    <Modal
      className={"remove-location-modal clean one"}
      visible={visible}
      onCancel={onCancel}
    >
      <header>
        <h2>{title}</h2>
      </header>
      <p>{body}</p>

      <footer>
        {userCount > 0 ? (
          <Button className={"primary"} size={"large"} onClick={() => { navigate(env.dashboardPath + `/account/team`);}}>
            <span>Assign locations</span>
          </Button>
        ) : screenCount > 0 ? (
          <Button className={"primary"} size={"large"} onClick={() => { navigate(env.dashboardPath + `/dsa/manage`);}}>
            <span>Remove screens</span>
          </Button>
        ) : (
          <>
            {!deleteForever && (
              <Button className={"primary-two secondary-option"} size={"large"} onClick={onRemoveAndDeleteFiles}>
                <span>Remove & Delete Files</span>
              </Button>
            )}
            {!deleteForever && (
              <Button className={"primary"} size={"large"} onClick={() => {setLoading(true); onRemoveAndTransferFiles(loc);}}>
                <span>Remove & Transfer Files</span>
              </Button>
            )}

            {deleteForever && (
              <Button className={"primary-two secondary-option"} size={"large"} onClick={() => onRemoveAndTransferFiles(loc)}>
                <span>Transfer files instead</span>
              </Button>
            )}
            {deleteForever && (
              <Button className={"primary"} size={"large"} loading={loading} onClick={() => {setLoading(true); onDelete(loc);}}>
                <span>Yes, delete files</span>
              </Button>
            )}
          </>
        )}

        <div className="cancel-link" onClick={() => onCancel()}>
          <span>Cancel</span>
        </div>
      </footer>
    </Modal>
  );
}
